export default __webpack_public_path__ + "static/media/QR_BZC_app_print_HD.b7bebae4.png";